import { t, useAuth } from "@keel/core";
import { SearchInput, useCrumbs } from "@keel/ui";
import { useEffect, useState } from "react";
import { BUILD, RELEASES, ReleaseEntry, useUnseen } from "../help";

/** Release notes (ERP-68): what every deploy brought, newest first, and which build this is. */
export function WhatsNewPage() {
  useCrumbs([{ label: t("Help"), to: "/help" }, { label: t("What's new") }]);
  const { me } = useAuth();
  const { markSeen } = useUnseen();
  const [q, setQ] = useState("");
  const [mine, setMine] = useState(true);
  // Reading the page counts as having seen them.
  // biome-ignore lint/correctness/useExhaustiveDependencies: once, on opening the page
  useEffect(markSeen, []);
  const words = q.toLowerCase().split(/\s+/).filter(Boolean);
  const notes = RELEASES.filter(
    (n) =>
      (!mine || !n.modules.length || n.modules.some((m) => (me.modules ?? []).includes(m))) &&
      words.every((w) => `${n.title} ${n.body} ${n.tickets.join(" ")}`.toLowerCase().includes(w)),
  );
  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>{t("What's new")}</h1>
          <p className="muted" style={{ margin: "4px 0 0" }}>
            {t("Everything each update brought. You're on build")} <span className="mono">{BUILD}</span>
            {RELEASES[0] && ` · ${t("latest notes {date}", { date: RELEASES[0].date })}`}.
          </p>
        </div>
        <div className="row" style={{ gap: 12, flexWrap: "wrap" }}>
          <label className="row" style={{ gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={mine} onChange={(e) => setMine(e.target.checked)} />
            {t("Only modules I have")}
          </label>
          <div style={{ width: "min(300px, 100%)" }}>
            <SearchInput value={q} onChange={setQ} placeholder={t("Search release notes…")} />
          </div>
        </div>
      </div>
      <div className="card">
        {notes.length ? (
          notes.map((n) => <ReleaseEntry key={n.id} n={n} />)
        ) : (
          <p className="muted release">{t("Nothing matches.")}</p>
        )}
      </div>
    </div>
  );
}
